.blockingDiv {
  height: 96px;
}

.row {  
  min-height: 86px;
  padding: 0px 32px;
  background-color: #f0f0f0;
  box-shadow: 0px 4px 20px -11px #000;
}

.icon {
  margin-left: 5px;
}

.font16 {
  font-size: 16px;
}
.containerKLW {
  max-width: 1140px;
  margin-left: auto;
  margin-right: auto;
}
